const TIMINGS = {
    MODAL_AUTOHIDE: 2000,
    SHOW_ANSWER: 1000,
};

export default TIMINGS;
